import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: []
}

export default (state = initialState, action) => {
	switch (action.type) {
        case actionTypes.SESRCH_BUSINESS_PLACES_REQUEST:
            return {
                ...state,
                loading: true,
            }
		case actionTypes.SESRCH_BUSINESS_PLACES_SUCCESS:
			return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.SESRCH_BUSINESS_PLACES_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.SESRCH_BUSINESS_PLACES_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.SESRCH_BUSINESS_PLACES_RESET_ALL:
            return initialState
		default:
			return state;
	}
};
